import React from 'react'
import MuiTabs, { TabsProps as MuiTabsProps } from '@mui/material/Tabs'

interface TabsProps extends MuiTabsProps {
  hover?: boolean
}

const Tabs = (props: TabsProps) => <MuiTabs className={props.hover ? 'MuiTabs-buttonsHover' : ''} {...props} />

export { Tabs, type TabsProps }
